export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6927.e279be6d.jpg";